const updateGeolocation = (payload) => {
    return {
        type: 'geolocation/update',
        payload
    }
}

export default updateGeolocation;